export default {
  titleCard: '', //Título del componente (nueva operación, eliminar operación...)
  cardListActive: false, //Componente con los campos de texto, botones y select
  dataTable: [], //Datos de la tabla
  dataOperationActive: {}, //Datos de la operación activa en el card
  cloneDataOperationActive: {},
}
